module.exports = __webpack_public_path__ + "af36852e239313f02f728a60120b791c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/umbrella-red-s.png
// module id = 2796
// module chunks = 0